/* 鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺?   HUSHAN SHOPIFY THEME 鈥?theme.js
   Consolidated from prototype JS files
   Sections: Loader 鈫?Cursor 鈫?Nav 鈫?Animations 鈫?Filter 鈫?FAQ 鈫?Gallery 鈫?Cart
鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺?*/

/* 鈹€鈹€鈹€ 00. MONEY FORMAT helper 鈹€鈹€鈹€ */
function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = parseInt(cents, 10);
  if (isNaN(cents)) return '';
  format = format || window.themeMoneyFormat || '${{amount}}';
  var value = (cents / 100).toFixed(2);
  return format.replace('{{amount}}', value).replace('{{amount_no_decimals}}', Math.round(cents / 100));
}

/* 鈹€鈹€鈹€ 02. GSAP GUARD 鈹€鈹€鈹€ */
(function() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    document.documentElement.classList.add('no-gsap');
    return;
  }
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  /* 鈹€鈹€鈹€ 03. CUSTOM CURSOR 鈹€鈹€鈹€ */
  (function(){
    const dot = document.getElementById('cur-dot');
    const ring = document.getElementById('cur-ring');
    if(!dot||!ring||window.matchMedia('(hover:none)').matches) return;
    let mx=0,my=0,rx=0,ry=0;
    document.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;gsap.to(dot,{left:mx,top:my,duration:0.05})});
    gsap.ticker.add(function(){rx+=(mx-rx)*0.1;ry+=(my-ry)*0.1;gsap.set(ring,{left:rx,top:ry})});
    var hoverTargets = 'a,button,.sys-card,.sol-card,.tech-card,.conf-card,.proj-card,.path-card,.n-item,.led-type,.audio-img,.lighting-img,.ae-item,.city-cta,.stadium-cta,.card,.prod-card,.case-card,.variant-btn,.gallery-thumb,.view-btn,.filter-tab';
    document.querySelectorAll(hoverTargets).forEach(function(el){
      el.addEventListener('mouseenter',function(){ring.classList.add('on')});
      el.addEventListener('mouseleave',function(){ring.classList.remove('on')});
    });
  })();

  /* 鈹€鈹€鈹€ 04. PAGE INIT (called after loader finishes) 鈹€鈹€鈹€ */
  window.initPage = function(){
    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    /* NAV SCROLL 鈥?sticky header + filter bar sync */
    var nav = document.getElementById('mainNav');
    if (nav) {
      ScrollTrigger.create({start:'80px top',onUpdate:function(self){
        var scrolled = self.progress > 0 || window.scrollY > 60;
        nav.classList.toggle('scrolled', scrolled);
        document.querySelectorAll('.collection-filter-bar').forEach(function(bar){
          bar.classList.toggle('scrolled-nav', scrolled);
        });
      }});
    }

    /* Keep primary hero content immediately paintable; animate only decoration. */
    gsap.to('.hero-bg img',{scale:1.06,duration:12,repeat:-1,yoyo:true,ease:'none'});

    /* 鈹€鈹€鈹€ CITY SCALE HERO 鈹€鈹€鈹€ */
    gsap.fromTo('.city-screen-tag',{y:-14,opacity:0},{y:0,opacity:1,duration:0.8,ease:'power3.out',delay:0.3});
    gsap.fromTo('.city-title',{y:36,opacity:0},{y:0,opacity:1,duration:1.1,ease:'power3.out',delay:0.5});
    gsap.fromTo('.city-desc',{y:24,opacity:0},{y:0,opacity:1,duration:0.9,ease:'power3.out',delay:0.75});
    gsap.fromTo('.city-cta',{y:16,opacity:0},{y:0,opacity:1,duration:0.8,ease:'power3.out',delay:0.95});
    gsap.to('.city-bg img',{scale:1.06},{scale:1,duration:14,repeat:-1,yoyo:true,ease:'none'});

    /* 鈹€鈹€鈹€ SECTION REVEAL 鈥?scroll-triggered fade-up 鈹€鈹€鈹€ */
    var revealItems = gsap.utils.toArray('.section-inner,.audio-split,.why-grid,.proj-grid,.led-banner,.conf-grid,.path-grid,.cta-shell')
      .filter(function(el){ return !el.classList.contains('sol-pin-wrapper'); });
    revealItems.forEach(function(el){
      gsap.fromTo(el,{y:40,opacity:0},{y:0,opacity:1,duration:1,ease:'power3.out',
        scrollTrigger:{trigger:el,start:'top 85%'}});
    });

    /* 鈹€鈹€鈹€ SECTION LABEL SLIDE 鈹€鈹€鈹€ */
    gsap.utils.toArray('.section-label').forEach(function(label){
      gsap.fromTo(label,{x:-20,opacity:0},{x:0,opacity:1,duration:0.8,ease:'power3.out',
        scrollTrigger:{trigger:label,start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ SECTION TITLE CLIP 鈹€鈹€鈹€ */
    gsap.utils.toArray('.section-title').forEach(function(title){
      gsap.fromTo(title,{clipPath:'inset(0 0 100% 0)',opacity:1},{clipPath:'inset(0 0 0% 0)',opacity:1,duration:1,ease:'power3.out',
        scrollTrigger:{trigger:title,start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ SYS CARDS 鈹€鈹€鈹€ */
    gsap.utils.toArray('.sys-card').forEach(function(card,i){
      gsap.fromTo(card,{y:30,opacity:0},{y:0,opacity:1,duration:0.7,delay:i*0.06,
        ease:'power3.out',scrollTrigger:{trigger:card,start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ TECH CARDS 鈹€鈹€鈹€ */
    gsap.utils.toArray('.tech-card').forEach(function(card,i){
      gsap.fromTo(card,{y:30,opacity:0},{y:0,opacity:1,duration:0.7,delay:i*0.07,
        ease:'power3.out',scrollTrigger:{trigger:card,start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ CARDS 鈥?stagger animation 鈹€鈹€鈹€ */
    gsap.utils.toArray('.card,.card-glass').forEach(function(card,i){
      gsap.fromTo(card,{y:30,opacity:0},{y:0,opacity:1,duration:0.7,delay:i*0.06,
        ease:'power3.out',scrollTrigger:{trigger:card,start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ PRODUCT CARDS 鈹€鈹€鈹€ */
    gsap.utils.toArray('.prod-card').forEach(function(card,i){
      gsap.fromTo(card,{y:30,opacity:0},{y:0,opacity:1,duration:0.6,delay:(i%4)*0.08,
        ease:'power3.out',scrollTrigger:{trigger:card,start:'top 90%'}});
    });

    /* 鈹€鈹€鈹€ CASE CARDS 鈹€鈹€鈹€ */
    gsap.utils.toArray('.case-card').forEach(function(card,i){
      gsap.fromTo(card,{y:30,opacity:0},{y:0,opacity:1,duration:0.7,delay:i*0.07,
        ease:'power3.out',scrollTrigger:{trigger:card,start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ SOLUTION CARDS 鈹€鈹€鈹€ */
    gsap.utils.toArray('.sol-card').forEach(function(card,i){
      gsap.fromTo(card,{y:30,opacity:0},{y:0,opacity:1,duration:0.7,delay:i*0.07,
        ease:'power3.out',scrollTrigger:{trigger:card,start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ STATS COUNT UP 鈹€鈹€鈹€ */
    gsap.utils.toArray('.stat-num .counter').forEach(function(el){
      var target = parseInt(el.textContent) || 0;
      var suffix = el.textContent.replace(/[0-9]/g,'');
      var obj = {v:0};
      gsap.to(obj,{v:target,duration:2.5,ease:'power2.out',
        scrollTrigger:{trigger:el.closest('.stats-band'),start:'top 80%'},
        onUpdate:function(){el.textContent=Math.round(obj.v)+suffix}
      });
    });

    /* 鈹€鈹€鈹€ IMAGE PARALLAX 鈹€鈹€鈹€ */
    gsap.utils.toArray('.hero-bg img,.page-hero-bg img,.cta-bg img,.article-hero-bg img,.case-card-img img,.sol-card-img img,.card-img img,.audio-img img,.lighting-img img,.lighting-side-img img,.conf-img img,.why-img img,.proj-card img,.path-img img,.led-banner img,.ae-img-box img,.city-bg img,.stadium-bg img').forEach(function(img){
      gsap.to(img,{
        yPercent:-8,ease:'none',
        scrollTrigger:{trigger:img.parentElement,start:'top bottom',end:'bottom top',scrub:true}
      });
    });

    /* 鈹€鈹€鈹€ FAQ 鈹€鈹€鈹€ */
    gsap.utils.toArray('.faq-item').forEach(function(item,i){
      gsap.fromTo(item,{y:20,opacity:0},{y:0,opacity:1,duration:0.5,delay:i*0.1,
        ease:'power3.out',scrollTrigger:{trigger:item,start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ CTA SECTION 鈹€鈹€鈹€ */
    gsap.fromTo('.cta-shell',{y:40,opacity:0},{y:0,opacity:1,duration:1,ease:'power3.out',
      scrollTrigger:{trigger:'.cta-section',start:'top 80%'}});

    /* 鈹€鈹€鈹€ LIGHTING BRIDGE 鈹€鈹€鈹€ */
    if (document.querySelector('.lighting-bridge')) {
      gsap.from('.lighting-bridge-head', {
        y: 36, opacity: 0, duration: 0.9, ease: 'power3.out',
        scrollTrigger: { trigger: '.lighting-bridge', start: 'top 78%' }
      });
      gsap.from('.lighting-bridge-frame', {
        y: 48, opacity: 0, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: '.lighting-bridge-frame', start: 'top 82%' }
      });
      gsap.from('.lighting-bridge-point', {
        y: 22, opacity: 0, duration: 0.8, stagger: 0.12, ease: 'power3.out',
        scrollTrigger: { trigger: '.lighting-bridge-strip', start: 'top 88%' }
      });
      gsap.to('.lighting-bridge-media img', {
        scale: 1.06, ease: 'none',
        scrollTrigger: { trigger: '.lighting-bridge', start: 'top bottom', end: 'bottom top', scrub: true }
      });
      gsap.to('.lighting-bridge-content', {
        y: -10, ease: 'none',
        scrollTrigger: { trigger: '.lighting-bridge', start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }

    /* 鈹€鈹€鈹€ ACOUSTIC ENGINEERING WAVE CANVAS 鈹€鈹€鈹€ */
    (function setupAcousticEngineering() {
      var canvas = document.getElementById('aeWaveCanvas');
      if (!canvas) return;
      var ctx = canvas.getContext('2d');
      var particles = [];
      var raf;
      var running = false;

      function initAE() {
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
        particles = [];
        var count = Math.floor(canvas.width / 9);
        for (var i = 0; i < count; i++) {
          particles.push({
            x: (canvas.width / count) * i,
            baseHeight: Math.random() * 40 + 20,
            speed: Math.random() * 0.1 + 0.02,
            phase: Math.random() * Math.PI * 2
          });
        }
      }

      function drawAE(advance) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var cy = canvas.height / 2;
        var len = particles.length;
        for (var i = 0; i < len; i++) {
          var p = particles[i];
          if (advance) p.phase += p.speed;
          var edgeMask = Math.sin((i / len) * Math.PI);
          var h = (Math.sin(p.phase) * 30 + p.baseHeight) * edgeMask * 1.5;
          ctx.beginPath();
          ctx.strokeStyle = '#c9a96e';
          ctx.lineWidth = 2;
          ctx.lineCap = 'round';
          ctx.moveTo(p.x, cy - h / 2);
          ctx.lineTo(p.x, cy + h / 2);
          ctx.globalAlpha = 0.8;
          ctx.stroke();
          ctx.fillStyle = '#c9a96e';
          ctx.globalAlpha = 0.4;
          ctx.fillRect(p.x - 1, cy - h / 2 - 2, 2, 2);
          ctx.fillRect(p.x - 1, cy + h / 2, 2, 2);
        }
        ctx.globalAlpha = 1;
      }

      function animateAE() {
        if (!running) return;
        drawAE(true);
        raf = requestAnimationFrame(animateAE);
      }

      function setAERunning(next) {
        if (running === next) return;
        running = next;
        if (running) animateAE();
        else if (raf) cancelAnimationFrame(raf);
      }

      initAE();
      drawAE(false);
      window.addEventListener('resize', function() { initAE(); if (!running) drawAE(false); }, { passive: true });

      if (!window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function(entries) {
            setAERunning(Boolean(entries[0] && entries[0].isIntersecting));
          }, { rootMargin: '120px 0px' }).observe(canvas);
        } else {
          setAERunning(true);
        }
      }

      if (document.querySelector('.integrated-systems')) {
        gsap.from('.ae-img-box', {
          y: 40, opacity: 0, duration: 1, ease: 'power3.out',
          scrollTrigger: { trigger: '.ae-img-box', start: 'top 85%' }
        });
        gsap.from('.ae-quote', {
          y: 24, opacity: 0, duration: 0.8, ease: 'power3.out',
          scrollTrigger: { trigger: '.ae-quote', start: 'top 85%' }
        });
        gsap.from('.ae-item', {
          y: 28, opacity: 0, duration: 0.8, stagger: 0.12, ease: 'power3.out',
          scrollTrigger: { trigger: '.ae-grid', start: 'top 82%' }
        });
      }
    })();

    /* 鈹€鈹€鈹€ STADIUM SCALE SPLIT HERO 鈹€鈹€鈹€ */
    if (document.querySelector('.stadium-scale')) {
      gsap.from('.stadium-content', {
        x: -40, opacity: 0, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: '.stadium-scale', start: 'top 80%' }
      });
      gsap.from('.stadium-bg', {
        x: 40, opacity: 0, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: '.stadium-scale', start: 'top 80%' }
      });
      gsap.from('.stadium-list li', {
        x: -20, opacity: 0, duration: 0.6, stagger: 0.12, ease: 'power3.out',
        scrollTrigger: { trigger: '.stadium-list', start: 'top 85%' }
      });
      gsap.from('.stadium-cta', {
        y: 14, opacity: 0, duration: 0.7, ease: 'power3.out',
        scrollTrigger: { trigger: '.stadium-cta', start: 'top 90%' }
      });
      gsap.to('.stadium-bg img', {
        scale: 1.05, ease: 'none',
        scrollTrigger: { trigger: '.stadium-scale', start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }

    /* 鈹€鈹€鈹€ NUMBERS COUNT UP 鈹€鈹€鈹€ */
    function countUp(el,target,suffix){
      var obj={v:0};
      gsap.to(obj,{v:target,duration:2.5,ease:'power2.out',
        scrollTrigger:{trigger:'.nums-grid',start:'top 80%'},
        onUpdate:function(){el.textContent=Math.round(obj.v)+suffix}
      });
    }
    var n1=document.getElementById('n1'), n2=document.getElementById('n2'), n3=document.getElementById('n3'), n4=document.getElementById('n4');
    if(n1) countUp(n1,30,'+');
    if(n2) countUp(n2,100,'+');
    if(n3) countUp(n3,8,'');
    if(n4) countUp(n4,500,'+');

    /* 鈹€鈹€鈹€ HORIZONTAL SOLUTIONS SCROLL 鈥?native CSS scroll (no GSAP) 鈹€鈹€鈹€ */
    /* Responsive: on desktop the track uses overflow-x:auto with scroll-snap.
       JS only adds wheel-to-scroll convenience on desktop if needed. */

    /* 鈹€鈹€鈹€ WHY ITEMS 鈹€鈹€鈹€ */
    gsap.utils.toArray('.why-item').forEach(function(item,i){
      gsap.fromTo(item,{x:30,opacity:0},{x:0,opacity:1,duration:0.7,delay:i*0.1,
        ease:'power3.out',scrollTrigger:{trigger:item,start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ CTA MINI 鈹€鈹€鈹€ */
    gsap.utils.toArray('.cta-mini').forEach(function(m,i){
      gsap.fromTo(m,{x:20,opacity:0},{x:0,opacity:1,duration:0.6,delay:i*0.1,
        ease:'power3.out',scrollTrigger:{trigger:'.cta-side',start:'top 88%'}});
    });

    /* 鈹€鈹€鈹€ PLAY BUTTON PULSE 鈹€鈹€鈹€ */
    gsap.to('.why-play',{scale:1.1,duration:2.5,repeat:-1,yoyo:true,ease:'sine.inOut'});

    /* 鈹€鈹€鈹€ 3D CARD HOVER TILT 鈹€鈹€鈹€ */
    document.querySelectorAll('.sys-card,.tech-card,.sol-card,.conf-card,.n-item,.led-type,.proj-card,.path-card,.card,.prod-card,.case-card').forEach(function(card){
      card.addEventListener('mousemove',function(e){
        var r=card.getBoundingClientRect();
        gsap.to(card,{rotateY:(e.clientX-r.left-r.width/2)*0.02,rotateX:-(e.clientY-r.top-r.height/2)*0.02,duration:0.4,ease:'power2.out'});
      });
      card.addEventListener('mouseleave',function(){gsap.to(card,{rotateY:0,rotateX:0,duration:0.6,ease:'power2.out'})});
    });

    /* 鈹€鈹€鈹€ SMOOTH ANCHOR SCROLL 鈹€鈹€鈹€ */
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click',function(e){
        var t=document.querySelector(a.getAttribute('href'));
        if(t){e.preventDefault();gsap.to(window,{scrollTo:t,duration:1.2,ease:'power3.inOut'})}
      });
    });

    /* Refresh after all assets settle */
    window.addEventListener('load', function() { ScrollTrigger.refresh(); });
  };

  /* Scripts are deferred, so content is never held behind a visual loader. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initPage, { once: true });
  } else {
    window.initPage();
  }

  /* 鈹€鈹€鈹€ 05. SAFETY REVEAL 鈥?unsticks any GSAP-set opacity:0 after 2s 鈹€鈹€鈹€ */
  setTimeout(function() {
    document.querySelectorAll('.hero-top,.hero-eyebrow,.hero-headline,.hero-desc,.hero-actions,.page-hero-content,.article-hero-content,.city-screen-tag,.city-title,.city-desc,.city-cta,.section-inner,.audio-split,.why-grid,.proj-grid,.led-banner,.conf-grid,.path-grid,.cta-shell,.card,.sys-card,.tech-card,.prod-card,.case-card,.sol-card,.ae-img-box,.ae-quote,.ae-item,.stadium-content,.stadium-bg,.stadium-list li,.stadium-cta,.why-item,.cta-mini,.faq-item').forEach(function(el){
      var s = el.style;
      if (s.opacity === '0' || s.opacity === '0.0') {
        s.opacity = '1';
        s.transform = '';
        s.transition = 'opacity 0.3s ease';
      }
    });
  }, 2000);

})();

/* 鈹€鈹€鈹€ 05b. SOLUTIONS SCROLL BUTTONS 鈹€鈹€鈹€ */
(function() {
  var track = document.getElementById('sol-track');
  var prevBtn = document.getElementById('sol-prev');
  var nextBtn = document.getElementById('sol-next');
  if (!track || !prevBtn || !nextBtn) return;

  function updateButtons() {
    var tol = 2;
    prevBtn.disabled = track.scrollLeft <= tol;
    nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - tol;
  }

  prevBtn.addEventListener('click', function() {
    track.scrollBy({ left: -340, behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', function() {
    track.scrollBy({ left: 340, behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons, { passive: true });
  updateButtons();
})();

/* 鈹€鈹€鈹€ 06. HAMBURGER MENU 鈹€鈹€鈹€ */
(function() {
  var ham = document.querySelector('.nav-ham');
  var navLinks = document.querySelector('.nav-links');
  if (ham && navLinks) {
    ham.addEventListener('click', function() {
      this.classList.toggle('active');
      navLinks.classList.toggle('active');
    });
  }
})();

/* 鈹€鈹€鈹€ 07. FILTER BAR 鈥?tabs, search, sort, view toggle 鈹€鈹€鈹€ */
(function() {
  var filterBar = document.querySelector('.collection-filter-bar');
  if (!filterBar) return;

  var filterTabs = filterBar.querySelectorAll('.filter-tab');
  var searchInput = filterBar.querySelector('.filter-search-input');
  var sortSelect = filterBar.querySelector('.filter-select');
  var viewBtns = filterBar.querySelectorAll('.view-btn');
  var resultsCount = filterBar.querySelector('.filter-results-info');

  /* Detect grid type (products or cases) */
  function getActiveGrid() {
    return document.querySelector('.prod-cards-grid') || document.querySelector('.cases-grid');
  }
  function getActiveCards() {
    var grid = getActiveGrid();
    if (!grid) return [];
    return grid.querySelectorAll('.prod-card, .case-card');
  }

  /* Tabs */
  filterTabs.forEach(function(tab){
    tab.addEventListener('click',function(){
      filterTabs.forEach(function(t){t.classList.remove('active')});
      this.classList.add('active');
      applyFilters();
    });
  });

  /* Search */
  if (searchInput) {
    searchInput.addEventListener('input', debounce(function(){
      applyFilters();
    }, 300));
  }

  /* Sort */
  if (sortSelect) {
    sortSelect.addEventListener('change', function(){
      sortProducts(this.value);
    });
  }

  /* View toggle */
  viewBtns.forEach(function(btn){
    btn.addEventListener('click',function(){
      viewBtns.forEach(function(b){b.classList.remove('active')});
      this.classList.add('active');
      var grid = getActiveGrid();
      if (grid) {
        grid.classList.toggle('list-view', this.dataset.view === 'list');
      }
    });
  });

  function getActiveTab() {
    var active = filterBar.querySelector('.filter-tab.active');
    return active ? active.dataset.filter || active.textContent.trim().toLowerCase() : 'all';
  }

  function applyFilters() {
    var tab = getActiveTab();
    var query = searchInput ? searchInput.value.toLowerCase().trim() : '';
    var grid = getActiveGrid();
    if (!grid) return;
    var cards = getActiveCards();
    var visible = 0;

    cards.forEach(function(card){
      var tags = (card.dataset.tags || '').toLowerCase();
      var type = (card.dataset.type || '').toLowerCase();
      var vendor = (card.dataset.vendor || '').toLowerCase();
      var text = (card.textContent || '').toLowerCase();
      var show = true;

      if (tab !== 'all' && tags.indexOf(tab) === -1 && type.indexOf(tab) === -1 && vendor.indexOf(tab) === -1) show = false;
      if (query && text.indexOf(query) === -1) show = false;

      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    if (resultsCount) {
      var countEl = resultsCount.querySelector('.results-count');
      if (countEl) countEl.textContent = visible;
      var suffix = resultsCount.querySelector('.results-suffix');
      if (suffix) suffix.textContent = visible !== 1 ? 'results' : 'result';
    }

    /* Show/hide no-results */
    var noRes = grid.parentElement.querySelector('.no-results');
    if (visible === 0 && cards.length > 0) {
      if (!noRes) {
        noRes = document.createElement('div');
        noRes.className = 'no-results';
        noRes.innerHTML = '<h3>No results found</h3><p>Try adjusting your search or filters</p>';
        grid.parentElement.appendChild(noRes);
      }
      noRes.style.display = '';
      grid.style.display = 'none';
    } else {
      if (noRes) noRes.style.display = 'none';
      grid.style.display = '';
    }
  }

  function sortProducts(sortBy) {
    var grid = getActiveGrid();
    if (!grid) return;
    var cards = Array.from(getActiveCards());

    cards.sort(function(a,b){
      var nameA = (a.querySelector('h4')||a.querySelector('h3')||{}).textContent || '';
      var nameB = (b.querySelector('h4')||b.querySelector('h3')||{}).textContent || '';
      switch(sortBy) {
        case 'title-ascending': return nameA.localeCompare(nameB);
        case 'title-descending': return nameB.localeCompare(nameA);
        case 'price-ascending': return (parseFloat(a.dataset.price)||0)-(parseFloat(b.dataset.price)||0);
        case 'price-descending': return (parseFloat(b.dataset.price)||0)-(parseFloat(a.dataset.price)||0);
        default: return 0;
      }
    });

    cards.forEach(function(card){grid.appendChild(card)});
  }

  function debounce(fn, wait) {
    var t;
    return function(){clearTimeout(t);t=setTimeout(fn.bind(this),wait)};
  }
})();

/* 鈹€鈹€鈹€ 08. FAQ ACCORDION 鈹€鈹€鈹€ */
(function() {
  document.querySelectorAll('.faq-item').forEach(function(item){
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', function(){
      var isOpen = item.classList.contains('open');
      /* Close siblings */
      var parent = item.parentElement;
      if (parent) {
        parent.querySelectorAll('.faq-item.open').forEach(function(sib){
          if (sib !== item) sib.classList.remove('open');
        });
      }
      item.classList.toggle('open');
      btn.setAttribute('aria-expanded', !isOpen);
    });
  });
})();

/* 鈹€鈹€鈹€ 09. PRODUCT GALLERY 鈥?thumbnail switching 鈹€鈹€鈹€ */
(function() {
  var gallery = document.querySelector('.product-gallery');
  var slides = document.querySelectorAll('.gallery-slide');
  var thumbs = document.querySelectorAll('.gallery-thumb');
  if (!gallery || slides.length === 0 || thumbs.length === 0) return;

  function setActive(index) {
    var targetIndex = String(index);
    slides.forEach(function(slide){
      slide.classList.toggle('active', slide.dataset.galleryIndex === targetIndex);
    });
    thumbs.forEach(function(thumb){
      thumb.classList.toggle('active', thumb.dataset.galleryIndex === targetIndex);
    });
  }

  function setActiveByImageId(imageId) {
    if (!imageId) return false;
    var target = document.querySelector('.gallery-slide[data-image-id="' + imageId + '"]');
    if (!target) return false;
    setActive(target.dataset.galleryIndex);
    return true;
  }

  function setActiveBySrc(src) {
    if (!src) return false;
    var found = null;
    slides.forEach(function(slide){
      if (!found && slide.dataset.src && (slide.dataset.src === src || src.indexOf(slide.dataset.src) !== -1 || slide.dataset.src.indexOf(src) !== -1)) {
        found = slide;
      }
    });
    if (!found) return false;
    setActive(found.dataset.galleryIndex);
    return true;
  }

  function getActiveSrc() {
    var active = document.querySelector('.gallery-slide.active');
    if (!active) return '';
    var img = active.querySelector('img');
    return active.dataset.src || (img ? img.src : '');
  }

  window.HushanGallery = {
    setActive: setActive,
    setActiveByImageId: setActiveByImageId,
    setActiveBySrc: setActiveBySrc,
    getActiveSrc: getActiveSrc
  };

  thumbs.forEach(function(thumb){
    var thumbImg = thumb.querySelector('img');
    if (thumbImg) {
      thumbImg.addEventListener('error', function(){
        var fallback = thumb.dataset.src;
        if (!fallback || this.dataset.usedFallback === '1') return;
        this.dataset.usedFallback = '1';
        this.src = fallback;
      });
    }

    thumb.addEventListener('click', function(){
      setActive(this.dataset.galleryIndex);
    });

    if (thumb.dataset.src) {
      var preload = new Image();
      preload.src = thumb.dataset.src;
    }
  });
})();

/* 鈹€鈹€鈹€ 09b. GALLERY ZOOM 鈥?lightbox modal 鈹€鈹€鈹€ */
(function() {
  var zoomBtn = document.getElementById('galleryZoom');
  if (!zoomBtn) return;

  var lightbox = document.createElement('div');
  lightbox.className = 'gallery-lightbox';
  lightbox.setAttribute('aria-hidden', 'true');
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('aria-label', 'Product image preview');
  lightbox.hidden = true;
  lightbox.innerHTML = '<div class="gallery-lightbox-bg"></div><div class="gallery-lightbox-body"><img src="" alt=""/><button class="gallery-lightbox-close" type="button" tabindex="-1" aria-label="Close image preview">&times;</button></div>';
  document.body.appendChild(lightbox);

  var lbImg = lightbox.querySelector('img');
  var bg = lightbox.querySelector('.gallery-lightbox-bg');
  var closeBtn = lightbox.querySelector('.gallery-lightbox-close');

  function open() {
    var src = window.HushanGallery && window.HushanGallery.getActiveSrc ? window.HushanGallery.getActiveSrc() : '';
    if (!src) {
      var activeImg = document.querySelector('.gallery-slide.active img, .gallery-main img');
      src = activeImg ? activeImg.src : '';
    }
    if (!src) return;
    lbImg.src = src;
    lightbox.hidden = false;
    lightbox.classList.add('active');
    lightbox.setAttribute('aria-hidden', 'false');
    closeBtn.removeAttribute('tabindex');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function close() {
    lightbox.classList.remove('active');
    lightbox.setAttribute('aria-hidden', 'true');
    closeBtn.setAttribute('tabindex', '-1');
    lightbox.hidden = true;
    document.body.style.overflow = '';
    zoomBtn.focus();
  }

  zoomBtn.addEventListener('click', open);
  bg.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
})();

/* 鈹€鈹€鈹€ 10. QUANTITY BUTTONS 鈹€鈹€鈹€ */
(function() {
  document.querySelectorAll('.qty-group').forEach(function(group){
    var input = group.querySelector('.qty-input');
    var minus = group.querySelector('[data-action="minus"]');
    var plus = group.querySelector('[data-action="plus"]');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function(){
        var v = parseInt(input.value) || 1;
        if (v > 1) input.value = v - 1;
        input.dispatchEvent(new Event('change', {bubbles: true}));
      });
    }
    if (plus) {
      plus.addEventListener('click', function(){
        var v = parseInt(input.value) || 0;
        input.value = v + 1;
        input.dispatchEvent(new Event('change', {bubbles: true}));
      });
    }
  });
})();

/* 鈹€鈹€鈹€ 11. VARIANT SELECTOR 鈥?option groups 鈫?hidden select 鈫?UI update 鈹€鈹€鈹€ */
(function() {
  var select = document.querySelector('select[name="id"]');
  if (!select) return;

  var priceWrap   = document.getElementById('productPrice');
  var skuEl       = document.getElementById('productSku');
  var mainImg     = document.querySelector('.gallery-slide.active img, .gallery-main img');
  var addBtn      = document.querySelector('.add-cart-btn');
  var soldOutEl   = document.querySelector('.sold-out-label');
  var addForm     = document.querySelector('.add-form');
  var hiddenId    = addForm ? addForm.querySelector('input[name="id"]') : null;
  var payForm     = document.querySelector('[id^="paymentForm-"]');
  var paySelect   = payForm ? payForm.querySelector('select[name="id"]') : null;
  var payQuantity = payForm ? payForm.querySelector('input[name="quantity"]') : null;
  var quantityInput = addForm ? addForm.querySelector('input[name="quantity"]') : null;
  var checkoutWrap = document.querySelector('.dynamic-checkout-wrap');

  function setAddButtonLabel(text) {
    if (!addBtn) return;
    var label = addBtn.querySelector('.add-cart-label');
    if (label) label.textContent = text;
    else addBtn.textContent = text;
  }

  function syncPaymentQuantity() {
    if (!payQuantity || !quantityInput) return;
    payQuantity.value = Math.max(1, parseInt(quantityInput.value, 10) || 1);
  }

  function updateUI() {
    var opt = select.options[select.selectedIndex];
    if (!opt) return;

    var price       = opt.dataset.price;
    var compareAt   = opt.dataset.comparePrice;
    var sku         = opt.dataset.sku;
    var available   = opt.dataset.available === 'true';
    var imgSrc      = opt.dataset.image;
    var imgId       = opt.dataset.imageId;

    /* Price */
    if (priceWrap) {
      var curSpan = priceWrap.querySelector('.price-current');
      var cmpSpan = priceWrap.querySelector('.price-compare');
      if (curSpan) curSpan.textContent = formatMoney(price);
      if (cmpSpan) {
        if (compareAt && parseInt(compareAt) > parseInt(price)) {
          cmpSpan.textContent = formatMoney(compareAt);
          cmpSpan.style.display = '';
        } else {
          cmpSpan.style.display = 'none';
        }
      }
    }

    /* SKU */
    if (skuEl && sku) skuEl.textContent = sku;

    /* Gallery main image */
    if (imgId && window.HushanGallery && window.HushanGallery.setActiveByImageId) {
      window.HushanGallery.setActiveByImageId(imgId);
    } else if (imgSrc && window.HushanGallery && window.HushanGallery.setActiveBySrc) {
      window.HushanGallery.setActiveBySrc(imgSrc);
    } else if (imgSrc && mainImg && imgSrc.indexOf('//') !== -1) {
      mainImg.src = imgSrc;
    }

    /* Highlight matching thumb 鈥?only when variant has a specific image */
    if (imgId) {
      document.querySelectorAll('.gallery-thumb').forEach(function(thumb){
        thumb.classList.remove('active');
        if (thumb.dataset.imageId === imgId) thumb.classList.add('active');
      });
    }

    /* Availability */
    if (addBtn) {
      if (available) {
        addBtn.disabled = false;
        setAddButtonLabel(addBtn.dataset.default || 'Add to Cart');
      } else {
        addBtn.disabled = true;
        setAddButtonLabel(addBtn.dataset.soldout || 'Sold Out');
      }
    }
    if (soldOutEl) soldOutEl.hidden = available;
    if (checkoutWrap) checkoutWrap.hidden = !available;

    /* Sync hidden input in add-to-cart form */
    if (hiddenId) hiddenId.value = opt.value;
    /* Sync payment form variant select */
    if (paySelect) {
      paySelect.value = opt.value;
      paySelect.dispatchEvent(new Event('change', {bubbles: true}));
    }
    syncPaymentQuantity();

    /* Keep a shareable variant URL without adding a navigation entry. */
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* Option button clicks */
  document.querySelectorAll('.option-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var optionIndex = this.dataset.optionIndex;
      var optionValue = this.dataset.optionValue;

      /* Mark active in this button's group */
      var group = this.closest('.option-values');
      if (group) {
        group.querySelectorAll('.option-btn').forEach(function(b){ b.classList.remove('active'); });
      }
      this.classList.add('active');

      /* Build selected options array [opt1_val, opt2_val, opt3_val] */
      var selected = [];
      document.querySelectorAll('.product-option-group').forEach(function(og, i){
        var activeBtn = og.querySelector('.option-btn.active');
        selected[i] = activeBtn ? activeBtn.dataset.optionValue : '';
      });

      /* Find matching variant in hidden select */
      var found = false;
      for (var i = 0; i < select.options.length; i++) {
        var o = select.options[i];
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          var optKey = 'option' + (j + 1);
          if (o.dataset[optKey] !== selected[j]) { match = false; break; }
        }
        if (match) {
          select.selectedIndex = i;
          select.dispatchEvent(new Event('change', {bubbles: true}));
          found = true;
          break;
        }
      }
    });
  });

  /* select change 鈫?refresh UI */
  select.addEventListener('change', updateUI);
  if (quantityInput) {
    quantityInput.addEventListener('change', syncPaymentQuantity);
    quantityInput.addEventListener('input', syncPaymentQuantity);
  }

  /* Initial sync */
  updateUI();
})();

/* 鈹€鈹€鈹€ 12. MEGA MENU 鈥?GSAP-animated dropdowns 鈹€鈹€鈹€ */
(function() {
  var nav = document.getElementById('mainNav');
  if (!nav) return;

  var navLinks = nav.querySelectorAll('.nav-links a[data-mm]');
  if (navLinks.length === 0) return;

  var mmContainer = document.getElementById('megaMenu');
  if (!mmContainer) return;

  var panels = mmContainer.querySelectorAll('.mm-panel');
  var activePanel = null;
  var hideTimer = null;
  var isAnimating = false;

  var useGSAP = typeof gsap !== 'undefined';

  function showPanel(key) {
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    if (isAnimating) return;

    var target = null;
    panels.forEach(function(p) {
      if (p.getAttribute('data-mm') === key) target = p;
      else { if (useGSAP) gsap.killTweensOf(p); p.style.display = 'none'; p.style.opacity = '0'; }
    });
    if (!target || activePanel === target) return;

    if (activePanel) hideActiveInstant();

    isAnimating = true;
    target.style.display = 'block';
    mmContainer.classList.add('open');
    activePanel = target;

    if (useGSAP) {
      var tl = gsap.timeline({ onComplete: function() { isAnimating = false; } });
      tl.fromTo(target, { opacity: 0, y: -16 }, { opacity: 1, y: 0, duration: 0.38, ease: 'power3.out' }, 0);
      var glowLine = mmContainer.querySelector('.mm-glow-line');
      if (glowLine) tl.fromTo(glowLine, { scaleX: 0, opacity: 0 }, { scaleX: 1, opacity: 1, duration: 0.5, ease: 'power3.out' }, 0);
      var cols = target.querySelectorAll('.mm-col');
      tl.fromTo(cols, { opacity: 0, x: -20, scale: 0.97 }, { opacity: 1, x: 0, scale: 1, duration: 0.5, stagger: 0.08, ease: 'power3.out' }, 0.04);
      var feat = target.querySelector('.mm-featured-card');
      if (feat) {
        tl.fromTo(feat, { opacity: 0, x: 16, scale: 0.96 }, { opacity: 1, x: 0, scale: 1, duration: 0.48, ease: 'power3.out' }, 0.1);
        var featImg = target.querySelector('.mm-featured-media img');
        if (featImg) tl.fromTo(featImg, { scale: 1.1, opacity: 0.4 }, { scale: 1, opacity: 1, duration: 0.6, ease: 'power2.out' }, 0.08);
      }
      var links = target.querySelectorAll('.mm-links li');
      tl.fromTo(links, { opacity: 0, x: -6 }, { opacity: 1, x: 0, duration: 0.3, stagger: 0.025, ease: 'power2.out' }, 0.12);
    } else {
      target.style.opacity = '1';
      target.style.transform = 'none';
      isAnimating = false;
    }
  }

  function hideActiveInstant() {
    if (activePanel) {
      if (useGSAP) {
        gsap.killTweensOf(activePanel);
        gsap.killTweensOf(activePanel.querySelectorAll('*'));
      }
      activePanel.style.opacity = '0';
      activePanel.style.display = 'none';
      activePanel = null;
    }
    mmContainer.classList.remove('open');
    isAnimating = false;
  }

  function hideActive() {
    if (!activePanel || isAnimating) return;
    var fading = activePanel;
    activePanel = null;
    isAnimating = true;
    if (useGSAP) {
      var tl = gsap.timeline({ onComplete: function() {
        fading.style.display = 'none';
        mmContainer.classList.remove('open');
        isAnimating = false;
      }});
      tl.to(fading, { opacity: 0, y: -8, duration: 0.22, ease: 'power2.in' }, 0);
      var glowLine = mmContainer.querySelector('.mm-glow-line');
      if (glowLine) tl.to(glowLine, { scaleX: 0, opacity: 0, duration: 0.15, ease: 'power2.in' }, 0);
    } else {
      fading.style.display = 'none';
      fading.style.opacity = '0';
      mmContainer.classList.remove('open');
      isAnimating = false;
    }
  }

  function scheduleHide() { hideTimer = setTimeout(hideActive, 200); }
  function cancelHide() { if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; } }

  navLinks.forEach(function(link) {
    var key = link.getAttribute('data-mm');
    if (!key) return;
    link.addEventListener('mouseenter', function() {
      cancelHide();
      if (activePanel && activePanel.getAttribute('data-mm') !== key) hideActiveInstant();
      showPanel(key);
    });
    link.addEventListener('mouseleave', function() { scheduleHide(); });
  });

  mmContainer.addEventListener('mouseenter', cancelHide);
  mmContainer.addEventListener('mouseleave', function() { scheduleHide(); });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { cancelHide(); hideActiveInstant(); }
  });
  window.addEventListener('blur', function() { hideActiveInstant(); });

  /* 鈹€鈹€鈹€ Mobile hamburger 鈹€鈹€鈹€ */
  var hamburger = nav.querySelector('.nav-ham');
  if (hamburger) {
    hamburger.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      nav.classList.toggle('nav--mobile-open');
      document.body.classList.toggle('nav-open');
      if (!expanded) {
        cancelHide(); hideActiveInstant();
      }
      // close mobile mega panel when hamburger closes
      nav.classList.remove('nav--mobile-mega');
      mmContainer.classList.remove('mobile-open');
      panels.forEach(function(p) { p.style.display = 'none'; });
    });
  }

  /* 鈹€鈹€鈹€ Mobile: tap mega link to show panel 鈹€鈹€鈹€ */
  var isMobile = function() { return window.matchMedia('(max-width: 1024px)').matches; };

  navLinks.forEach(function(link) {
    var key = link.getAttribute('data-mm');
    if (!key) return;
    link.addEventListener('click', function(e) {
      if (!isMobile() || !nav.classList.contains('nav--mobile-open')) return;
      e.preventDefault();
      panels.forEach(function(p) { p.style.display = 'none'; });
      var target = mmContainer.querySelector('.mm-panel[data-mm="' + key + '"]');
      if (target) { target.style.display = 'block'; }
      nav.classList.add('nav--mobile-mega');
      mmContainer.classList.add('mobile-open');
    });
  });

  var mobileBack = document.getElementById('mmMobileBack');
  if (mobileBack) {
    mobileBack.addEventListener('click', function() {
      nav.classList.remove('nav--mobile-mega');
      mmContainer.classList.remove('mobile-open');
      panels.forEach(function(p) { p.style.display = 'none'; });
    });
  }
})();

/* 鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺?   CART 鈥?Drawer + AJAX operations
鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺?*/
(function(){
  var backdrop = document.getElementById('cartBackdrop');
  var drawer = document.getElementById('cartDrawer');
  var body = document.body;
  if(!backdrop || !drawer) return;

  function openCart(){backdrop.classList.add('open');drawer.classList.add('open');backdrop.setAttribute('aria-hidden','false');drawer.setAttribute('aria-hidden','false');drawer.removeAttribute('inert');body.style.overflow='hidden'}
  function closeCart(){backdrop.classList.remove('open');drawer.classList.remove('open');backdrop.setAttribute('aria-hidden','true');drawer.setAttribute('aria-hidden','true');drawer.setAttribute('inert','');body.style.overflow=''}

  /* Toggle buttons */
  var cartToggle = document.getElementById('cartToggle');
  if(cartToggle){cartToggle.addEventListener('click',function(e){e.preventDefault();openCart()})}
  var cartClose = document.getElementById('cartClose');
  if(cartClose){cartClose.addEventListener('click',closeCart)}
  backdrop.addEventListener('click',closeCart);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart()});

  /* AJAX 鈥?fetch cart state (for badge update) */
  function fetchCartState(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      var counts = document.querySelectorAll('.cart-count');
      counts.forEach(function(c){c.textContent=cart.item_count;c.style.display=cart.item_count>0?'flex':'none'})
    }).catch(function(){})
  }

  /* AJAX 鈥?add to cart (intercept product form) */
  function attachAddToCart(){
    var forms = document.querySelectorAll('form.add-form[action="/cart/add"]');
    forms.forEach(function(form){
      if(form.dataset.cartAjax) return;
      form.dataset.cartAjax = '1';
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var label = btn ? btn.querySelector('.add-cart-label') : null;
        if(btn){btn.disabled=true;if(label){label.textContent='Adding...'}else{btn.textContent='Adding...'}}
        var data = new FormData(form);
        fetch('/cart/add.js',{method:'POST',body:data})
        .then(function(r){
          if(!r.ok){throw new Error('Cart add failed: ' + r.status)}
          return r.json();
        })
        .then(function(){
          if(btn){btn.disabled=false;if(label){label.textContent=btn.getAttribute('data-default')||'Add to Cart'}else{btn.textContent=btn.getAttribute('data-default')||'Add to Cart'}}
          fetchCartState();
          openCart();
          refreshCartDrawer();
        })
        .catch(function(err){
          if(btn){btn.disabled=false;if(label){label.textContent=btn.getAttribute('data-default')||'Add to Cart'}else{btn.textContent=btn.getAttribute('data-default')||'Add to Cart'}}
          alert('Unable to add this item right now. Please try again.');
          console.error(err);
        })
      });
    });
  }

  /* AJAX 鈥?quantity change */
  function attachQtyButtons(container){
    var qtyBtns = container.querySelectorAll('.qty-btn');
    qtyBtns.forEach(function(btn){
      if(btn.dataset.cartBound) return;
      btn.dataset.cartBound = '1';
      btn.addEventListener('click',function(){
        var line = this.getAttribute('data-line');
        var input = container.querySelector('.qty-input[data-line="'+line+'"]');
        if(!input) return;
        var val = parseInt(input.value)||1;
        var dir = this.getAttribute('data-dir');
        var newVal = dir==='+'?val+1:val-1;
        if(newVal<1){removeCartItem(line);return}
        updateCartItem(line,newVal);
      });
    });

    var removeBtns = container.querySelectorAll('.cart-drawer-item-remove, .cart-page-item-remove');
    removeBtns.forEach(function(btn){
      if(btn.dataset.cartBound) return;
      btn.dataset.cartBound = '1';
      btn.addEventListener('click',function(){
        var line = this.getAttribute('data-line');
        removeCartItem(line);
      });
    });
  }

  function updateCartItem(line,quantity){
    var payload = {updates:{}};
    payload.updates[line] = quantity;
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
    .then(function(r){return r.json()})
    .then(function(){
      fetchCartState();
      refreshCartDrawer();
    })
    .catch(function(err){console.error(err)})
  }

  function removeCartItem(line){
    updateCartItem(line,0);
  }

  function refreshCartDrawer(){
    fetch('/?section_id=cart-drawer')
    .then(function(r){return r.text()})
    .then(function(html){
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var newBody = temp.querySelector('#cartBody');
      var newFooter = temp.querySelector('.cart-drawer-footer');
      var oldBody = document.getElementById('cartBody');
      var oldFooter = drawer.querySelector('.cart-drawer-footer');
      if(newBody && oldBody){oldBody.innerHTML = newBody.innerHTML}
      if(newFooter){if(oldFooter){oldFooter.outerHTML = newFooter.outerHTML}else{drawer.appendChild(newFooter)}}
      else{if(oldFooter){oldFooter.remove()}}
      attachQtyButtons(drawer);
    })
    .catch(function(err){console.error(err)})
  }

  /* Init */
  attachAddToCart();
  attachQtyButtons(drawer);
  attachQtyButtons(document);

  /* Observe DOM for dynamically added add-to-cart forms (variant switches etc) */
  if(typeof MutationObserver !== 'undefined'){
    var observer = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if(node.nodeType===1){
            if(node.querySelectorAll){
              var forms = node.querySelectorAll('form.add-form[action="/cart/add"]');
              if(forms.length>0) attachAddToCart();
            }
          }
        });
      });
    });
    observer.observe(document.body,{childList:true,subtree:true});
  }
})();

/* 鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺?   ACCOUNT DROPDOWN
鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺愨晲鈺?*/
(function(){
  var toggle = document.getElementById('accountToggle');
  var dropdown = document.getElementById('accountDropdown');
  if(!toggle || !dropdown) return;

  toggle.addEventListener('click',function(e){
    e.preventDefault();
    var open = dropdown.classList.toggle('open');
    toggle.setAttribute('aria-expanded',open);
  });

  document.addEventListener('click',function(e){
    if(!toggle.contains(e.target) && !dropdown.contains(e.target)){
      dropdown.classList.remove('open');
      toggle.setAttribute('aria-expanded','false');
    }
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      dropdown.classList.remove('open');
      toggle.setAttribute('aria-expanded','false');
    }
  });
})();


/* Shopify official customer-account component page blur */
(function initShopifyAccountPageBlur(){
  var boundAccounts = new WeakSet();
  var blurLayer = document.getElementById('ShopifyAccountPageBlur');

  if(!blurLayer) return;

  function openBlur(){
    blurLayer.classList.add('is-open');
    blurLayer.setAttribute('aria-hidden','false');
  }

  function closeBlur(){
    blurLayer.classList.remove('is-open');
    blurLayer.setAttribute('aria-hidden','true');
  }

  function bindAccountComponents(root){
    var scope = root && root.querySelectorAll ? root : document;
    var accounts = scope.querySelectorAll('shopify-account');

    accounts.forEach(function(account){
      if(boundAccounts.has(account)) return;
      boundAccounts.add(account);
      account.addEventListener('open',openBlur);
      account.addEventListener('close',closeBlur);
    });
  }

  bindAccountComponents(document);

  document.addEventListener('shopify:section:load',function(event){
    bindAccountComponents(event.target);
  });

  window.addEventListener('pageshow',closeBlur);
  window.addEventListener('pagehide',closeBlur);
  document.addEventListener('keydown',function(event){
    if(event.key === 'Escape') closeBlur();
  });
})();
